import { render, staticRenderFns } from "./inventoryProvince.vue?vue&type=template&id=67e4bd76&scoped=true&"
import script from "./inventoryProvince.vue?vue&type=script&lang=js&"
export * from "./inventoryProvince.vue?vue&type=script&lang=js&"
import style0 from "./inventoryProvince.vue?vue&type=style&index=0&id=67e4bd76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e4bd76",
  null
  
)

export default component.exports